<template>
    <div>
        <div class="container p-5">
            <div class="row justify-content-center text-center">
                <div class="col-12">
                    <h1 class="cR4">404</h1>
                    <h2 class="text-light">⚠️ Houston, we have a problem... ⚠️</h2>
                    <h3 class="text-secondary">It looks like the page you are trying to reach doesn't exist!</h3>
                    <h2 class="text-center text-secondary"><small style="font-size: 1.5rem;">View the <a href="/faq" class="text-decoration-underline text-secondary" target="_blank">FAQ</a> for Assistance</small></h2>
                </div>
            </div>
        </div>
    </div>
</template>